import {useEffect, useState} from 'react';
import {useSearchParams} from 'react-router-dom';

import {
  DEFAULT_TRANSACTIONS_FILTER_STATE,
  parseFilterFromSearchParams,
  TRANSACTIONS_FILTER_QUERY_PARAMS
} from '../config/transactions-filter.config';

import type {TransactionsFilterState} from '../config/transactions-filter.config';

// Re-applied on param change: deep links can land while the tab is already mounted.
export function useTransactionsUrlFilter() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [filter, setFilter] = useState<TransactionsFilterState>(() =>
    parseFilterFromSearchParams(searchParams, DEFAULT_TRANSACTIONS_FILTER_STATE)
  );

  useEffect(() => {
    if (!TRANSACTIONS_FILTER_QUERY_PARAMS.some(key => searchParams.has(key))) return;
    setFilter(parseFilterFromSearchParams(searchParams, DEFAULT_TRANSACTIONS_FILTER_STATE));
    const next = new URLSearchParams(searchParams);
    TRANSACTIONS_FILTER_QUERY_PARAMS.forEach(key => next.delete(key));
    setSearchParams(next, {replace: true});
  }, [searchParams, setSearchParams]);

  return {filter, setFilter};
}
